import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { LoaderService, PlatformService } from '@services';
import { ModalService, MongoService } from 'wacom';
import { SafeResourceUrl  } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import * as es6printJS from "print-js";
import { saveAs } from "file-saver"

@Component({
	selector: 'invoicetemplate',
	templateUrl: './invoicetemplate.component.html',
	styleUrls: ['./invoicetemplate.component.scss']
})
export class InvoicetemplateComponent implements OnInit{
	public invoice: any = {margin:{}};
	public close;
	@ViewChild('logoInput') logoInput: any;
	constructor(public ps: PlatformService, private mongo: MongoService, private http: HttpClient, private loader: LoaderService, public modal: ModalService, private eref: ElementRef) {}
	ngOnInit() {
		this.eref.nativeElement.closest('.modal').addEventListener('click', (event) => {
			this.closeModal();
		});
		this.loader.show({ 
			modal: true,
		}, document.querySelector('.modal-box'));
		this.mongo.on('platform', () => {
			this.loader.remove();
			this.invoice = JSON.parse(JSON.stringify(this.ps.platform.data.invoice));
		});
	}
	save() {
		this.ps.platform.data.invoice = this.invoice;
		this.ps.save();
		this.close();
	}
	public preview: any = false;
	public previewUrl: SafeResourceUrl;
	generatePreview() {
		this.loader.show({ 
			modal: true,
			transparent: true,
			preventClick: true
		}, document.querySelector('.modal-box'));
		this.http.post('/api/invoice/preview', this.invoice, { responseType: 'blob'}).subscribe(resp=> {
			resp.text().then(value => {
				const fileReader = new FileReader();
				fileReader.onload = (event: any) => {
					const arrayBuffer = event.target.result;
					this.previewUrl = new Uint8Array(arrayBuffer);
					this.preview = resp;
				};
				fileReader.readAsArrayBuffer(resp);
			});
			this.loader.remove();
		});
	}

	@ViewChild('pdfViewer', { static: false }) pdfViewer: ElementRef;
	public formats: any = {
		Letter: {
			width: 8.5,
			height: 11 
		},
		Legal: {
			width: 8.5,
			height: 14 
		},
		Tabloid: {
			width: 11,
			height: 17
		},
		Ledger: {
			width: 17,
			height: 11 
		},
		A0: {
			width: 33.1,
			height: 46.8 
		},
		A1: {
			width: 23.4,
			height: 33.1 
		},
		A2: {
			width: 16.54,
			height: 23.4 
		},
		A3: {
			width: 11.7,
			height: 16.54 
		},
		A4: {
			width: 8.27,
			height: 11.7 
		},
		A5: {
			width: 5.83,
			height: 8.27
		},
		A6: {
			width: 4.13,
			height: 5.83
		}
	}
	getHeight() {
		if (this.pdfViewer) {
			const width = this.pdfViewer.nativeElement.clientWidth;
			const format = this.formats[this.invoice.format];
			const coefficient = format.width / format.height;
			return width / coefficient + 10 + 'px';
		} else return '500px';
	}
	onLogoSelected(event) {
		const file = event.target.files[0];
		if (file) {
			const reader = new FileReader();
			reader.onload = () => {
				this.invoice.logo = reader.result as string;
			};
			reader.readAsDataURL(file);
		}
	}
	public logo_sizes = [
		{
			name: 'Small',
			size: 60
		}, {
			name: 'Medium',
			size: 90
		}, {
			name: 'Large',
			size: 120
		}
	];
	public fonts: any = [
		'Times New Roman',
		'Open Sans',
		'Roboto',
		'Lato',
		'Montserrat',
		'Raleway',
		'Nunito',
		'Source Sans Pro',
		'PT Sans',
		'Playfair Display',
		'Quicksand',
		'Geologica',
		'Poppins',
		'Roboto Slab',
		'Barlow'
	];
	public templates: any = [
		{
			name: 'Professional',
			id: 'professional'
		}, {
			name: 'Classic',
			id: 'classic'
		}, {
			name: 'Modern',
			id: 'modern'
		}, {
			name: 'Minimalist',
			id: 'minimalist'
		}
	];
	onTemplateSelected(event) {
		this.http.post('/api/invoice/template', {template: event}).subscribe(resp=> {
			this.invoice = resp;
		});
	}
	printPreview() {
		es6printJS(URL.createObjectURL(this.preview), 'pdf');
	}
	downloadPreview() {
		saveAs(this.preview, 'Invoice preview.pdf');
	}
	uploadLogo() {
		this.logoInput.nativeElement.click();
	}
	deleteLogo() {
		this.logoInput.nativeElement.value = '';
		this.invoice.logo = '';
	}
	closeModal() {
		if(!this.preview) {
			if(this.hasChanges()) {
				this.modal.show({
					component: 'deleteAlert',
					title: 'Unsaved Changes',
					body: `You have unsaved changes. Do you want to save before exiting?`,
					primary_btn: 'Save',
					second_btn: 'Don’t Save',
					on_add: ()=> {
						this.save();
					},
					on_close: ()=> {
						this.close();
					}
				});
			} else {
				this.close();
			}
		} else {
			this.preview = false;
		}
	}
	hasChanges() {
		const keys = new Set([...Object.keys(this.ps.platform.data.invoice), ...Object.keys(this.invoice)]);
		for (let key of keys) {
			const val1 = this.ps.platform.data.invoice[key];
			const val2 = this.invoice[key];
			
			const bothAreObjects = typeof val1 === 'object' && val1 !== null &&
								   typeof val2 === 'object' && val2 !== null;
			
			if (Array.isArray(val1) && Array.isArray(val2)) {
				if (val1.length !== val2.length) return true;
				for (let i = 0; i < val1.length; i++) {
					const areObjects = typeof val1[i] === 'object' && val1[i] !== null &&
									   typeof val2[i] === 'object' && val2[i] !== null;					
					if(areObjects) {
						const keys = new Set([...Object.keys(val1[i]), ...Object.keys(val2[i])]);
						for (let key of keys) {
							if (val1[i][key] !== val2[i][key]) {
								return true;
							}
						}
					} else {
						if (JSON.stringify(val1[i]) !== JSON.stringify(val2[i])) {
						  	return true;
						}
					}
				}
			} else if (bothAreObjects) {
				const keys1 = Object.keys(val1);
				const keys2 = Object.keys(val2);
				if (keys1.length !== keys2.length) return true;
				for (let subKey of keys1) {
					if (val1[subKey] !== val2[subKey]) return true;
				}
			} else {
			  	if (val1 !== val2) return true;
			}
		}
		return false;
	}
}
